export enum DataVisualizationOption {
  // Visualizations for train acceleration and velocity
  speed = 'speed',
  // Remote Square Mean deviation of acceleration
  rmse = 'rmse',
  // TimeSeries history and trends
  timeSeries = 'timeSeries'
}